import { MarppleshopAppLinkPage } from './MarppleshopAppLinkPage';

export const marppleshopAppLinkRouter = {
  '/@/app_link': MarppleshopAppLinkPage,
};
